import dayjs from 'dayjs';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export default async function getLotModels(lotId, callback) {
	console.log('getLotModels lotId', lotId);
	var getAvailability = firebase
		.functions()
		.httpsCallable('CheckModelAvailabilityOnLot');
	var thisBody = {
		lotNumber: lotId,
		projectCode: PROJECT_CODE.projectCode,
	};
	getAvailability(thisBody).then((returned) => {
		console.log('getLotModels returned', returned.data, lotId);

		var modelsObj = returned.data;

		var modelsKeys = Object.keys(modelsObj);

		var modelsArr = [];

		var buildingsArr = [];

		// firebase
		// 	.database()
		// 	.ref(
		// 		'/kavtek_lots/' +
		// 			PROJECT_CODE.projectCode +
		// 			'/' +
		// 			lotId +
		// 			'/buildings/'
		// 	)
		// 	.once('value', (snapshot) => {
		// 		var buildingsObj = snapshot.val();

		// 		var buildingsObjKeys = Object.keys(buildingsObj);

		// 		console.log('buildingsObjKeys', buildingsObjKeys);

		// 		buildingsObjKeys.forEach((key) => {
		// 			var building = Object.keys(building)[0];

		// 			console.log('buildingbuilding', Object.keys(building)[0]);

		// 			buildingsArr.push(building);
		// 		});
		// 	});

		// console.log('Thius is the two arrays', modelsKeys, buildingsArr);

		modelsKeys.forEach((key) => {
			modelsArr.push({
				[key]: modelsObj[key],
			});
		});

		console.log('modelsArrmodelsArrmodelsArr', modelsArr);
		callback(modelsArr);
	});
}
